import { CrownOutlined, GlobalOutlined, SafetyOutlined } from '@ant-design/icons'
import { Avatar, Dropdown, Menu } from 'antd'
import { useAtom } from 'jotai'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { userInfoAtom } from '@/modules/user'

export const AvatarDropdown = () => {
  const [user] = useAtom(userInfoAtom)
  const { i18n, t } = useTranslation()

  const menu = (
    <Menu>
      <Menu.Item
        key='language'
        icon={<GlobalOutlined />}
        onClick={() => i18n.changeLanguage(i18n.resolvedLanguage === 'en' ? 'zh' : 'en')}
      >
        {i18n.resolvedLanguage === 'en' ? '中文' : 'English'}
      </Menu.Item>
      {user.roles.length ? <Menu.Divider /> : null}
      {user.roles.map((r) => {
        if (r.role === 'super') {
          return (
            <Menu.Item key='admin' icon={<CrownOutlined />}>
              {t('superAdmin')}
            </Menu.Item>
          )
        }
        return (
          <Menu.Item key='admin' icon={<SafetyOutlined />}>
            {/* TODO 翻译 ACL 中的角色 */}
            {t(r.role)}
          </Menu.Item>
        )
      })}
    </Menu>
  )

  return (
    <Dropdown overlay={menu} trigger={['click']}>
      <Avatar className='cursor-pointer' src={user.avatar} />
    </Dropdown>
  )
}
